import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { GlobalStyles } from "@mui/material";

const registerFirebaseServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("✅ Firebase Service Worker registered:", registration);
    } catch (err) {
      console.error("❌ Service Worker registration failed:", err);
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStyles
        styles={{
          "*::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "*::-webkit-scrollbar-track": {
            backgroundColor: "#f0f0f0",
            borderRadius: "10px",
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#c1c1c1",
            borderRadius: "10px",
            border: "2px solid #f0f0f0",
          },
          "*::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#a0a0a0",
          },
          "*": {
            scrollbarWidth: "thin",
            scrollbarColor: "#c1c1c1 transparent",
          },
          "*.scroll-container": {
            overflow: "auto",
            scrollbarWidth: "none" /* Firefox */,
          },
          "*.scroll-container::-webkit-scrollbar": {
            display: "none" /* Chrome, Safari */,
          },
        }}
      />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// Register after the app is mounted
registerFirebaseServiceWorker();
